module.exports = __webpack_public_path__ + "05bd79517574304357b3c7aa495fbba3.svg";